import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageCensusReportsCreate from 'hcp/components/page/census/reports/create';

<template>
  {{pageTitle (t "page-title.license-utilization-reporting.reports")}}

  <PageCensusReportsCreate />
</template>
